module.exports = __webpack_public_path__ + "img/bibliotheca.7215173b.png";